import { useTranslation } from "react-i18next";
import { ProductSpec } from "../../../../../../components";
import { productTypeEnum } from "../../../../../../enumerations/productEnum";
import styles from "./style.module.scss";

const OptionRadio = ({
  optionData,
  isActive,
  onItemClick,
  isMethod,
}: {
  optionData: any;
  isActive: boolean;
  onItemClick: () => void;
  isMethod: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`${styles.optionRadio} ${isActive ? styles.active : ""}`}
      onClick={onItemClick}
    >
      {isMethod ? (
        <div
          className={`${styles.daysText} ${
            optionData?.type === productTypeEnum.DAILY &&
            optionData?.network_volume > 0
              ? styles.isDaily
              : ""
          }`}
        >
          {`${ProductSpec(t, optionData?.network_volume, optionData?.type)}`}
        </div>
      ) : (
        <div className={styles.daysText}>
          {`${t("normal.days", { days: optionData?.days })}`}
        </div>
      )}
    </div>
  );
};

export default OptionRadio;
